import { LatLong } from 'types/asset';
import Device from 'types/models/device';
import SamplePoint from 'types/models/samplePoint';

export function getLatLongData(gpsSamplePoint: SamplePoint) {
  // TODO: Cleanup, this is bad optional chaining
  const latLngElevation =
    gpsSamplePoint.lastSampleData?.multiDimValues?.sampleDim?.map(
      ({ rwValue }) => rwValue
    );

  // No longer need to use elevation.
  // Interpret a latitude or longitude value of 0 as an error.
  const latLong =
    latLngElevation && latLngElevation[0] && latLngElevation[1]
      ? ([latLngElevation[0], latLngElevation[1]] as LatLong)
      : undefined;

  return latLong;
}

export function getDeviceLocation(device: Device) {
  if (device.positionLat || device.positionLong) {
    return [device.positionLat, device.positionLong] as LatLong;
  }

  return device.gpsSamplePoint ? getLatLongData(device.gpsSamplePoint) : undefined;
}
